export default __webpack_public_path__ + "static/media/telegram.11ff135a.svg";